import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { Toaster, toast } from "sonner";
import Landing from "@/components/Landing";
import Terms from "@/components/Terms";
import Privacy from "@/components/Privacy";
import Newsletter, { NewsletterPost } from "@/components/Newsletter";
import Admin from "@/components/Admin";
import Press from "@/components/Press";
import Blog, { BlogPost } from "@/components/Blog";
import ChatWidget from "@/components/ChatWidget";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  const handleSubscribe = async ({ name, email, source, medium, campaign, referrer, newsletter_opt_in }) => {
    try {
      const res = await axios.post(`${API}/newsletter/subscribe`, {
        name: name || null,
        email,
        source: source || null,
        medium: medium || null,
        campaign: campaign || null,
        referrer: referrer || null,
        newsletter_opt_in: !!newsletter_opt_in,
      });
      toast.success(res.data.message || "Welcome to the Awakening!", {
        description: newsletter_opt_in
          ? `We'll notify ${res.data.email} at launch and send you AI essays.`
          : `We'll notify ${res.data.email} at launch.`,
      });
      // Tell Brevo's automation tracker who this visitor is. If the tracker isn't
      // loaded (no client_key configured) this no-ops harmlessly.
      try {
        if (window.sendinblue && typeof window.sendinblue.identify === "function") {
          window.sendinblue.identify(email, {
            FIRSTNAME: name || "",
            SIGNUP_SOURCE: source || "direct",
            SIGNUP_CAMPAIGN: campaign || "",
            NEWSLETTER_OPT_IN: newsletter_opt_in ? "yes" : "no",
          });
          window.sendinblue.track("newsletter_signup", { email, source: source || "direct", newsletter_opt_in: !!newsletter_opt_in });
        }
      } catch (_) { /* ignore */ }
      // Notify the homepage social-proof counter to refetch immediately so
      // the visitor sees themselves added to "preparing readers".
      try { window.dispatchEvent(new CustomEvent("aip:subscribed", { detail: { email } })); } catch (_) { /* ignore */ }
      return { ok: true };
    } catch (err) {
      const detail = err?.response?.data?.detail;
      const msg = Array.isArray(detail) ? detail[0]?.msg : detail;
      toast.error(msg || "Could not subscribe. Please try again.");
      return { ok: false };
    }
  };

  return (
    <div className="App">
      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={{
          style: {
            background: "rgba(15, 23, 42, 0.95)",
            border: "1px solid rgba(0, 240, 255, 0.3)",
            color: "#fff",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing onSubscribe={handleSubscribe} />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/newsletter" element={<Newsletter />} />
          <Route path="/newsletter/:slug" element={<NewsletterPost />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/press" element={<Press />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
        <ChatWidget />
      </BrowserRouter>
    </div>
  );
}

export default App;
